import { Component } from '@angular/core';

@Component({
    selector: 'app-health-check',
    standalone: true,
    templateUrl: './health-check.component.html'
})
export class HealthCheckComponent {

}
